import { render, staticRenderFns } from "./AddFamilyMember.vue?vue&type=template&id=635fdb7a&scoped=true&"
import script from "./AddFamilyMember.vue?vue&type=script&lang=js&"
export * from "./AddFamilyMember.vue?vue&type=script&lang=js&"
import style0 from "./AddFamilyMember.vue?vue&type=style&index=0&id=635fdb7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635fdb7a",
  null
  
)

export default component.exports